// extracted by mini-css-extract-plugin
export default {"content":"DownloadApp_content__2Cz6y","qrcode":"DownloadApp_qrcode__uop8J","download":"DownloadApp_download__zCZ5R","mobileImage":"DownloadApp_mobileImage__Hmw44"};